// extracted by mini-css-extract-plugin
module.exports = {"form":"WristSize_form__kzN_h","selectWrapper":"WristSize_selectWrapper__tjl7H"};